﻿import React from "react";
import "../Timesheets.css";
import { Box, Card, IconButton, List, Modal, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSelector } from "react-redux";
import { English } from "../../../constant/EnglishFallback";

function GoalsList({ 
  open, 
  onClose, 
  goallist, 
  onGoalPressed, 
  onCategoryPressed 
}) {
  const { multiLanguageData } = useSelector((state) => state?.main);
  const LanguageData = multiLanguageData?.TimeSheet || {};
  const { TEXT_GOAL_LIST = English.TimeSheet.TEXT_GOAL_LIST } = LanguageData || {};

  return (
    <Modal open={open} onClose={onClose}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6" sx={{ ml: 1 }}>
            {TEXT_GOAL_LIST}
          </Typography>
          <Stack direction={"row"}>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Stack>
        </Box>

        <Box
          sx={{
            marginTop: "10px",
            paddingBottom: "10px",
            height: "460px",
            overflow: "auto",
            scrollbarWidth: "none"
          }}>
          <List disablePadding>
            {goallist?.length !== 0 ? (
              <Stack sx={{ gap: 1 }} >
                {goallist?.map((item, index) => {
                  return (
                    <Card
                      key={index.toString()}
                      className="pagelist-content"
                      sx={{ marginTop: "0px", padding: "10px", cursor: "pointer" }}>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: "bold" }}
                        onClick={() => {
                          onGoalPressed(item);
                        }}>
                        {item?.goalName}
                      </Typography>
                      {item.categoryList?.map((category, catIndex) => (
                        <Typography
                          key={`category-${index}-${catIndex}`}
                          variant="body1"
                          onClick={() => {
                            onCategoryPressed(category);
                          }}>
                          {category.categoryName}
                        </Typography>
                      ))}
                    </Card>
                  );
                })}
              </Stack>
            ) : (
              <Typography>No data Available</Typography>
            )}
          </List>
        </Box>
      </Box>
    </Modal>
  );
}

export default GoalsList;

